import React, {useState} from "react";
import NoCardsItem from "../../common/items/NoCardsItem";
import PaymentMethodCardRow from "./PaymentMethodCardRow";

const PaymentMethodCardContainer = ({
                                        data, setLoading, handleServerError, setServerResponse,
                                        selectedPaymentType, setShouldRefresh
                                    }) => {
    const allPaymentMethods = data || [];

    if (allPaymentMethods.length === 0)
        return <NoCardsItem/>;

    return (
        <div className={'row'} data-testid={'paymentMethodCardContainerDiv'}>
            <div className={'col-12'}>
                {
                    allPaymentMethods.map((paymentMethod) => {
                        return (
                            <PaymentMethodCardRow paymentMethod={paymentMethod}
                                                  setLoading={setLoading}
                                                  handleError={handleServerError}
                                                  selectedPaymentType={selectedPaymentType}
                                                  setServerResponse={setServerResponse}
                                                  allPaymentMethods={allPaymentMethods}
                                                  setShouldRefresh={setShouldRefresh}/>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default PaymentMethodCardContainer;